import React from 'react';
import { BannerReact } from 'common/components/banner';
import { BannerTheme, BannerType } from 'common/components/banner/types';
import { useTranslation } from 'common/i18n/hooks';
export function ExperimentPageBannerConfigure() {
  const {
    t
  } = useTranslation();
  return <BannerReact headerText={t("experiments.banner.configure.title")} bodyText={t("experiments.banner.configure.body")} theme={BannerTheme.Base} type={BannerType.Embedded} icon='settings' data-sentry-element="BannerReact" data-sentry-component="ExperimentPageBannerConfigure" data-sentry-source-file="_configure.tsx" />;
}